import { Input } from '@ordo/ui/input'
import { Label } from '@ordo/ui/label'

export function ForwardingDestinationFields({
  idPrefix,
  destinationUrl,
  audience,
  onDestinationUrlChange,
  onAudienceChange,
  disabled,
}: {
  idPrefix: string
  destinationUrl: string
  audience: string
  onDestinationUrlChange: (value: string) => void
  onAudienceChange: (value: string) => void
  disabled?: boolean
}) {
  return (
    <div className="space-y-4">
      <div className="min-w-0 space-y-1.5">
        <Label htmlFor={`${idPrefix}-url`}>Forward to URL</Label>
        <Input
          id={`${idPrefix}-url`}
          type="url"
          value={destinationUrl}
          onChange={(event) => onDestinationUrlChange(event.target.value)}
          placeholder="https://schedule.ordo.com/api/webhooks/boombox/inbound"
          disabled={disabled}
          required
          autoComplete="off"
        />
      </div>
      <div className="min-w-0 space-y-1.5">
        <Label htmlFor={`${idPrefix}-audience`}>Receiving app</Label>
        <Input
          id={`${idPrefix}-audience`}
          value={audience}
          onChange={(event) => onAudienceChange(event.target.value)}
          placeholder="schedule"
          pattern="[a-z][a-z0-9_-]{0,63}"
          maxLength={64}
          disabled={disabled}
          required
          autoComplete="off"
          aria-describedby={`${idPrefix}-authentication`}
        />
        <p id={`${idPrefix}-authentication`} className="text-xs text-muted-foreground">
          Boombox authenticates deliveries to this app.
        </p>
      </div>
    </div>
  )
}
